// eslint-disable-next-line import/prefer-default-export
export const getUrl = (...args) => {
  try {
    return new URL(...args);
  } catch (e) {
    // nothing
  }

  return undefined;
};
